import {useState} from "react";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import {BottomSheet} from "../layout";
import {Button, Textarea, YStack} from "@chayka/ui";
import {showErrorToast, showSuccessToast} from "@/utils/toast";

interface CancelBookingBottomSheetProps {
  bookingIds: number[];
  isOpen: boolean;
  onClose: () => void;
}

export const CancelBookingBottomSheet: React.FC<CancelBookingBottomSheetProps> = ({
  bookingIds,
  isOpen,
  onClose,
}) => {
  const queryClient = useQueryClient();

  const {data: fineAmountData} = useQuery({
    ...trpc.booking.checkCancellationFines.queryOptions({bookingIds}),
    enabled: isOpen,
  });

  const cancelBookingsMutator = useMutation({
    ...trpc.booking.cancel.mutationOptions(),
    onSuccess: async () => {
      await queryClient.invalidateQueries(trpc.booking.list.queryFilter());
      await queryClient.invalidateQueries(trpc.auth.me.queryFilter());
      onClose();
      showSuccessToast("Бронирование успешно отменено");
    },
    onError: () => {
      showErrorToast("Не удалось отменить бронирование");
    },
  });

  const [comment, setComment] = useState("");

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <YStack className="gap-4">
        <div className="text-center">Почему вы хотите отменить бронирование?</div>
        <Textarea
          className="text-sm"
          placeholder="Ваш комментарий"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {fineAmountData && fineAmountData.fineAmount > 0 && (
          <div className="text-error text-sm text-center">
            Внимание! Отмена бронирования повлечёт штраф в размере {fineAmountData.fineAmount}{" "}
            рублей.
          </div>
        )}
        <Button
          variant="primary"
          size="small"
          disabled={comment.trim() === "" || cancelBookingsMutator.isPending}
          onClick={() => cancelBookingsMutator.mutate({bookingIds, comment})}
        >
          Отменить
        </Button>
        <Button variant="secondary" size="small" onClick={onClose}>
          Назад
        </Button>
      </YStack>
    </BottomSheet>
  );
};
